exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VerifiedInfo-displayGrid-1V97m {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: 30px auto;\r\n}\r\n\r\n.VerifiedInfo-displayFlex-3UoR5 {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t    -ms-flex-align: center;\r\n\t        align-items: center;\r\n\t-webkit-box-pack: justify;\r\n\t    -ms-flex-pack: justify;\r\n\t        justify-content: space-between;\r\n}\r\n\r\n.VerifiedInfo-infoPadding-w8nYF {\r\n\tpadding: 0px 24px 24px 24px;\r\n}\r\n\r\n.VerifiedInfo-tickIcon-1z93x {\r\n\twidth: 100%;\r\n\tmax-width: 12px;\r\n}\r\n\r\n.VerifiedInfo-googleIcon-1F7Ji{\r\n\twidth: 20px;\r\n}\r\n\r\n.VerifiedInfo-fbIcon-1FFtY{\r\n\twidth: 15px;\r\n}\r\n\r\n.VerifiedInfo-emailTop-1ie9O{\r\n\tposition: relative;\r\n\ttop: -2px;\r\n}", ""]);

// exports
exports.locals = {
	"displayGrid": "VerifiedInfo-displayGrid-1V97m",
	"displayFlex": "VerifiedInfo-displayFlex-3UoR5",
	"infoPadding": "VerifiedInfo-infoPadding-w8nYF",
	"tickIcon": "VerifiedInfo-tickIcon-1z93x",
	"googleIcon": "VerifiedInfo-googleIcon-1F7Ji",
	"fbIcon": "VerifiedInfo-fbIcon-1FFtY",
	"emailTop": "VerifiedInfo-emailTop-1ie9O"
};